import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';

import { childrenPropType } from 'config/childrenPropType';

import rule from './PageWrapper.rule';

const PageWrapper = ({ header, children }) => {
    const { css } = useFela();

    return (
        <div className={css(rule)}>
            <h2>{header}</h2>
            <div>{children}</div>
        </div>
    );
};

PageWrapper.propTypes = {
    header: PropTypes.node.isRequired,
    children: childrenPropType.isRequired,
};

export default PageWrapper;
